import { render, staticRenderFns } from "./tomaintainlist.vue?vue&type=template&id=b040a25a&scoped=true"
import script from "./tomaintainlist.vue?vue&type=script&lang=js"
export * from "./tomaintainlist.vue?vue&type=script&lang=js"
import style0 from "./tomaintainlist.vue?vue&type=style&index=0&id=b040a25a&prod&lang=scss"
import style1 from "./tomaintainlist.vue?vue&type=style&index=1&id=b040a25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b040a25a",
  null
  
)

export default component.exports